<template>
  <div
    class="sheets-container-component"
  >
    <transition name="fade">
      <div
        v-if="sheets.length > 0"
        class="sheets-overlay"
      >
        <focus-trap
          :active="activeFocusTrap"
          :escape-deactivates="true"
          :click-outside-deactivates="true"
          @update:active="activeFocusTrap = $event"
          @deactivate="removeLast"
        >
          <sheet
            v-for="s in sheets"
            :key="s.id"
            :options="s.options"
            :sheet-type="s.sheetType"
            @hide="hideSheet(s.sheet)"
          />
        </focus-trap>
      </div>
    </transition>
  </div>
</template>

<script>
import Sheet from '@/components/sheets/sheet.vue';

export default {
  components: {
    Sheet,
  },
  data() {
    return {
      activeFocusTrap: false,
      sheets: [],
    };
  },
  created() {
    this.registerListeners();
  },
  methods: {
    add({ sheetType, options }) {
      this.activeFocusTrap = true;
      this.addScrollBlock();
      this.sheets.push({ id: 123, sheetType, options });
    },
    addScrollBlock() {
      document.body.classList.add('__scrollblock');
    },
    hideSheet(sheet) {
      this.remove({ sheet });
    },
    registerListeners() {
      this.$sheets.subscription.$on('show', this.add);
      this.$sheets.subscription.$on('hide', this.remove);
    },
    remove({ sheet }) {
      this.activeFocusTrap = false;
      this.removeScrollBlock();
      this.sheets = this.sheets.filter(s => s.sheet !== sheet);
    },
    removeLast() {
      this.sheets.pop();
    },
    removeScrollBlock() {
      document.body.classList.remove('__scrollblock');
    },
  },
};
</script>

<style lang="scss">
.__scrollblock {
  overflow: hidden;
}
.sheets-container-component {
  .sheets-overlay {
    background-color: rgba(0,0,0,0.7);
    bottom: 0;
    left: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .15s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>
